var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefreshcircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6819 22.9738C12.9669 23.4488 13.3153 23.8921 13.7111 24.288C15.1154 25.6872 17.017 26.4729 18.9994 26.4729C20.9818 26.4729 22.8835 25.6872 24.2878 24.288C25.4234 23.142 26.1567 21.6586 26.3778 20.0605M11.6211 17.9388C11.8428 16.3871 12.5236 14.8988 13.7111 13.7113C15.1154 12.312 17.017 11.5264 18.9994 11.5264C20.9818 11.5264 22.8835 12.312 24.2878 13.7113C24.6994 14.123 25.0319 14.5663 25.3169 15.0255",
    stroke: "#108DA0",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3818 27.2012V22.9737H16.6093M25.6185 10.7979V15.0254H21.391",
    stroke: "#108DA0",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33366 9.50033C4.35449 12.1445 3.16699 15.4378 3.16699 19.0003C3.16699 27.7403 10.2603 34.8337 19.0003 34.8337C27.7403 34.8337 34.8337 27.7403 34.8337 19.0003C34.8337 10.2603 27.7403 3.16699 19.0003 3.16699C16.7362 3.16699 14.567 3.64199 12.6195 4.51283",
    stroke: "#108DA0",
    strokeWidth: 2.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshcircle);
export default __webpack_public_path__ + "static/media/refreshcircle.d1735e818cc029b912c17dd9273aaaff.svg";
export { ForwardRef as ReactComponent };